import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
// import { immer } from "zustand/middleware/immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { mergeDeepLeft } from "ramda";
// import devDebug from "../Helpers/debug";
import devDebug from "../Helpers/debug";
import idbKeyvalAdapter from "./1_utility";


const tenderSearchTabAdminKey = `${import.meta.env.VITE_TENDER_SEARCH_TAB_ADMIN_KEY}_${import.meta.env.VITE_VERSION}`;
const tenderSearchTabKey = `${import.meta.env.VITE_TENDER_SEARCH_TAB_KEY}_${import.meta.env.VITE_VERSION}`;
const companiesSearchTabKey = `${import.meta.env.VITE_COMPANIES_SEARCH_TAB_KEY}_${import.meta.env.VITE_VERSION}`;
const tenderAwardsSearchTabKey = `${import.meta.env.VITE_AWARDS_SEARCH_TAB_KEY}_${import.meta.env.VITE_VERSION}`;

let tab = {};

tab[tenderSearchTabAdminKey] = 0;
tab[tenderSearchTabKey] = 0;
tab[companiesSearchTabKey] = 0;
tab[tenderAwardsSearchTabKey] = 0;

const initialState = {
  tab: tab,
  tenderStrategies: [],
  storeAwards: [],
  awardsFull: null,
  tenderStrategiesLoaded: false,
  applyToAllTabs: false,
  awardInfoID: null,
  showAwardInfoModal: false,
  inputCPV: "",
  hideListCPVSearch: true,
  award: null,
  awardStatus: "loading",
  awardError: "",
  //variables for Excel export
  awardArrayToDownload: [],
  multiXLSXStatus: "",
  totalIterations: 1,
  currentIteration: 0,
  includeAdminColumns: false,
  numAwardsToDownload: 50,
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useTenderAwardsSearchStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      // ---------------------- EXCEL DOWNLOADS ---------------------------
      setIncludeAdminColumns: (payload) =>
        set((state) => {
          state.includeAdminColumns = payload;
        }),
      setNumAwardsToDownload: (payload) =>
        set((state) => {
          state.numAwardsToDownload = payload;
        }),
      setAwardArrayToDownload: (payload) =>
        set((state) => {
          state.awardArrayToDownload = [...state.awardArrayToDownload, payload];
          if (state.currentIteration > state.totalIterations) {
            state.awardArrayToDownload.sort((a, b) => a.currentIteration - b.currentIteration);
            state.awardArrayToDownload = state.awardArrayToDownload
              .flatMap(obj => obj.results)
              .slice(0, state.numAwardsToDownload);
            state.multiXLSXStatus = "loaded";
          } else {
            devDebug("did not match yet")
          }
        }),
      resetAwardArrayToDownload: () =>
        set((state) => {
          state.awardArrayToDownload = [];
        }),
      setMultiXLSXStatus: (payload) =>
        set((state) => {
          state.multiXLSXStatus = payload;
        }),
      setTotalIterations: (payload) =>
        set((state) => {
          state.totalIterations = payload;
        }),
      setCurrentIteration: (payload) =>
        set((state) => {
          state.currentIteration = payload;
        }),
      increaseCurrentIteration: () =>
        set((state) => {
          state.currentIteration++
        }),

      // ---------------------- AWARDS SEARCH ---------------------------

      setAward: (award) =>
        set((state) => {
          state.award = award;
        }),
      setAwardStatus: (awardStatus) =>
        set((state) => {
          state.awardStatus = awardStatus;
        }),
      setAwardError: (awardError) =>
        set((state) => {
          state.awardError = awardError;
        }),
      setInputCPV: (payload) =>
        set((state) => {
          state.inputCPV = payload;
        }),
      setHideListCPVSearch: (payload) =>
        set((state) => {
          state.hideListCPVSearch = payload;
        }),
      setAwardInfoID: (payload) =>
        set((state) => {
          state.awardInfoID = payload;
        }),
      setShowAwardInfoModal: (payload) =>
        set((state) => {
          state.showAwardInfoModal = payload;
        }),
      setStoreAwards: (payload) =>
        set((state) => {
          state.awardsFull = payload
          let awrds = {};
          for (let award of payload.results) {
            awrds[award.id] = award;
          }
          state.storeAwards = awrds;
        }),
      settableQueryParams: (payload) =>
        set((state) => {
          state.tableQueryParams = payload;
        }),
      setTab: (payload, section) =>
        set((state) => {
          state.tab[section] = payload;
        }),
      setApplyToAllTabs: (payload) =>
        set((state) => {
          state.applyToAllTabs = payload;
        }),
      setTenderStrategies: (tabName, payload) =>
        set((state) => {
          state.tenderStrategies = payload;
          const actualTab = { ...state.tab };
          if (actualTab[tabName] >= state.tenderStrategies.length) {
            state.tab[tabName] = 0;
          }
        }),
      setTenderStrategiesLoaded: (payload) =>
        set((state) => {
          state.tenderStrategiesLoaded = payload;
        }),
      resetState: () => {
        useTenderAwardsSearchStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              ![
                "tenderStrategies",
                "tenderStrategiesLoaded",
                "awardStatus",
                "awardInfoID",
                "showAwardInfoModal",
                "awardArrayToDownload",
                "multiXLSXStatus",
                "totalIterations",
                "currentIteration"
              ].includes(key)
          )
        ),
      name: "tenderAwardsSearch1",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[tenderAwardsSearchStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[tenderAwardsSearchStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[tenderAwardsSearchStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[tenderAwardsSearchStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[tenderAwardsSearchStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[tenderAwardsSearchStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[tenderAwardsSearchStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[tenderAwardsSearchStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[tenderAwardsSearchStore] Error during rehydration. Store name: "tenderAwardsSearchStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[tenderAwardsSearchStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
